<template>
  <a
    @click="openService"
    class="service-icon-btn j-service-float-btn"
    :class="[isShowBtn ? 'show' : false]"
    @mouseenter="isShowBtn = true"
    href="javascript:;"
    v-if="needBtn"
  >
    <em class="ico iconfont icon-service"></em>
  </a>
</template>

<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import { mapGetters } from 'vuex';
import contactService from '@mixins/officialWebStore/contactService';
import { clickButton } from '@plugins/biPoint/_configWebstoreV2';

export default {
  mixins: [contactService],
  props: [
    'serverId',
    'roleId',
    'roleName',
    'gameId',
    'isUidLogin',
    'uid',
    'loginAccount'
  ],
  data() {
    return {
      needBtn: globalConfig.getHrefParam('hideService') != 1,
      isShowBtn: false,
      timer: null
    };
  },
  computed: {
    ...mapGetters(['isJpPlatform'])
  },
  watch: {
    isShowBtn(newV) {
      if (newV) {
        this.timer = setTimeout(() => {
          clearTimeout(this.timer);
          this.timer = null;
          this.isShowBtn = false;
        }, 2000);
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      }
    }
  },
  methods: {
    openService() {
      clickButton({
        btnName: 'customer_service',
        locationKey: this.$route.meta.pageName
      });
      if (!this.isShowBtn) {
        this.isShowBtn = true;
      }
      this.isJpPlatform
        ? this.jpService()
        : this.openGlobalService({
            gameId: this.gameId,
            roleId: this.roleId,
            roleName: this.roleName,
            serverId: this.serverId,
            isUidLogin: this.isUidLogin,
            uid: this.uid,
            loginAccount: this.loginAccount
          });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
$w: 106px;
.service-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  position: fixed;
  right: -35px;
  bottom: 30vh;
  background-size: contain;
  cursor: pointer;
  transition: all 0.2s;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  @include g-gradient-btn();
  &.show {
    right: 0;
  }
  .ico {
    font-size: 83px;
    color: #fff;
  }
}
@media screen and (orientation: landscape) {
  .service-icon-btn {
    width: 70px;
    height: 70px;
    right: -20px;
    .ico {
      font-size: 53px;
      color: #fff;
    }
  }
}
</style>
